// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-b7dd8438]{color:#000;text-decoration:none}.chat[data-v-b7dd8438]{width:100%}.chat .message[data-v-b7dd8438]{background-color:#ecf0f3;border-radius:5px}.chat[data-v-b7dd8438]:before{content:\"\";width:0;height:0;display:block;border-left:5px solid transparent;border-right:5px solid #ecf0f3;border-top:5px solid #ecf0f3;border-bottom:5px solid transparent;position:absolute;top:0;left:-3px}.right .message[data-v-b7dd8438]{background-color:#0087db;color:#fff}", ""]);
// Exports
module.exports = exports;
